export default {
  state: {
    snackbar: false,
    message: "",
  },

  mutations: {
    setSnackbar(state, payload) {
      state.snackbar = payload;
    },

    setSnackbarMessage(state, payload) {
      state.message = payload;
    },
  },

  actions: {
    addSnackbar: ({ commit }, payload) => {
      commit("setSnackbar", payload);
    },

    addSnackbarMessage: ({ commit }, payload) => {
      commit("setSnackbarMessage", payload);
    },
  },

  getters: {
    getSnackbar: (state) => state.snackbar,
    getSnackbarMessage: (state) => state.message,
  },
};
